import queryString from "qs"
import urlifyLib from "urlify"

export const callAll = (...fns) => (...args) =>
  fns.forEach((fn) => fn && fn(...args))

export const date_sort_asc = (date1, date2) => {
  // This is a comparison function that will result in dates being sorted in
  // DESCENDING order.
  if (new Date(date1) > new Date(date2)) return 1
  if (new Date(date1) < new Date(date2)) return -1
  return 0
}

export const absoluteifyMenu = (menu, absoluteUrl) =>
  menu.map((item) => ({
    ...item,
    items: item.items.map((child) => ({
      ...child,
      url: absoluteUrl + child.url,
      items: child.items.map((gchild) => ({
        ...gchild,
        url: absoluteUrl + gchild.url
      }))
    }))
  }))

const neonReplacePattern = new RegExp(/(outputfields.idnamepair.name)\d*/, "mg")
// because this api want's the same key for each value, like a freaking goat.
export const neonify = ({ outputfields, params = {} }) =>
  queryString
    .stringify(
      outputfields.reduce(
        (acc, fieldName) => {
          acc.params[`outputfields.idnamepair.name${acc.i}`] = fieldName
          acc.i += 1
          return acc
        },
        { params, i: 0 }
      ).params
    )
    .replace(neonReplacePattern, "$1")

export const urlify = urlifyLib.create({
  addEToUmlauts: true,
  szToSs: true,
  spaces: "-",
  nonPrintable: "-",
  trim: true
})

export function slugify(text) {
  return text
    ? text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/[^\w\-]+/g, "") // Remove all non-word chars
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, "") // Trim - from end of text
    : text
}

export function setHtml(content) {
  return {
    dangerouslySetInnerHTML: {
      __html: content ? content : ""
    }
  }
}

export function wrapIframesInResponsiveVideo() {
  if (typeof document !== "undefined") {
    const iframes = document.getElementsByTagName
      ? document.getElementsByTagName("iframe")
      : null

    if (iframes)
      Object.keys(iframes).map((i) => {
        const iframe = iframes[i]
        let src

        if (iframe.getAttribute) {
          src = iframe.getAttribute("src")
        }

        if (
          src &&
          (src.includes("youtube.com") ||
            src.includes("vimeo.com") ||
            src.includes("livestream.com"))
        ) {
          const wrapper = document.createElement("div")

          wrapper.className = "video-responsive"

          wrapper.innerHTML = iframe.outerHTML

          iframe.parentNode.insertBefore(wrapper, iframe)

          if (iframe.remove) iframe.remove()
        }
      })
  }
}

export function scrollIt(
  destination,
  duration = 200,
  easing = "linear",
  callback
) {
  if (typeof document !== "undefined") {
    const easings = {
      linear(t) {
        return t
      },
      easeInQuad(t) {
        return t * t
      },
      easeOutQuad(t) {
        return t * (2 - t)
      },
      easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
      },
      easeInCubic(t) {
        return t * t * t
      },
      easeOutCubic(t) {
        return --t * t * t + 1
      },
      easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
      },
      easeInQuart(t) {
        return t * t * t * t
      },
      easeOutQuart(t) {
        return 1 - --t * t * t * t
      },
      easeInOutQuart(t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t
      },
      easeInQuint(t) {
        return t * t * t * t * t
      },
      easeOutQuint(t) {
        return 1 + --t * t * t * t * t
      },
      easeInOutQuint(t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t
      }
    }
    const start = window.pageYOffset
    const startTime =
      "now" in window.performance ? performance.now() : new Date().getTime()

    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    )
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.getElementsByTagName("body")[0].clientHeight
    const destinationOffset =
      typeof destination === "number" ? destination : destination.offsetTop
    const destinationOffsetToScroll = Math.round(
      documentHeight - destinationOffset < windowHeight
        ? documentHeight - windowHeight
        : destinationOffset
    )

    if ("requestAnimationFrame" in window === false) {
      window.scroll(0, destinationOffsetToScroll)
      if (callback) {
        callback()
      }
      return
    }

    function scroll() {
      const now =
        "now" in window.performance ? performance.now() : new Date().getTime()
      const time = Math.min(1, (now - startTime) / duration)
      const timeFunction = easings[easing](time)
      window.scroll(
        0,
        Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start)
      )

      if (window.pageYOffset === destinationOffsetToScroll) {
        if (callback) {
          callback()
        }
        return
      }

      requestAnimationFrame(scroll)
    }

    scroll()
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/utils.js